// main page for admin mode, contains admin menu and user suggestion table

import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Cookies from "universal-cookie";

//components:
import AdminMenu from '../../components/database/admin-mode/AdminMenu'
import SuggestionTable from '../../components/database/admin-mode/SuggestionTable';


export default function AdminHome() {
    const location = useLocation();
    const navigate = useNavigate(); 
    const cookies = new Cookies();

    // logout function, remove token and navigate to login page
    const logout = () => {
        cookies.remove("TOKEN", { path: "/" });
        navigate('/login');
    }

    return (
        <div>
            <AdminMenu user={location.state ? location.state.username : 'Admin'} logout={logout}/>
            <SuggestionTable/>
        </div>
    )
}